var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lookup_title_lyout defalut_boder_bottom_line"},[_c('i',{class:'iconfont '+_vm.iconfont,style:({'margin-right':_vm.distance})}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }